import {
    Chart,
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    BubbleController,
    DoughnutController,
    LineController,
    PieController,
    PolarAreaController,
    RadarController,
    ScatterController,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    RadialLinearScale,
    TimeScale,
    TimeSeriesScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip,
} from 'chart.js';
(()=>{
    Chart.register(
        ArcElement,
        LineElement,
        BarElement,
        PointElement,
        BarController,
        BubbleController,
        DoughnutController,
        LineController,
        PieController,
        PolarAreaController,
        RadarController,
        ScatterController,
        CategoryScale,
        LinearScale,
        LogarithmicScale,
        RadialLinearScale,
        TimeScale,
        TimeSeriesScale,
        Decimation,
        Filler,
        Legend,
        Title,
        Tooltip
    )


    const $form = $('#user-profile-form');
    const $companyForm = $('#company-profile-form');
    const $photoPreview = $('#user-photo-preview');
    const chartElement = document.getElementById('inspirations-stats-chart');
    if(chartElement) {
        const chartCtx = chartElement.getContext('2d');

        const DEFAULT_CHART_FORMAT = {
            chart: {
                type: 'line',
                data: {
                    labels: [],
                    datasets: []
                },
                options: {
                    plugins: {
                        legend: {
                            display: true,
                            position: 'bottom',
                            align: 'start'
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: true,
                            grid: {
                                display: false
                            }
                        },
                        x: {
                            grid: {
                                display: false
                            }
                        }
                    }
                }
            },
            datasets: {
                views: {
                    label: chartElement.dataset.labelName,
                    data: [],
                    pointRadius: 4,
                    backgroundColor: [
                        'rgba(162, 89, 255, 1)',
                    ],
                    borderColor: [
                        'rgba(162, 89, 255, 1)',
                    ],
                    borderWidth: 2
                }
            },
        };

        const settings = {};
        Object.assign(settings, DEFAULT_CHART_FORMAT.chart)
        settings.data.labels = window.chartLabels;

        let viewsData = {};
        Object.assign(viewsData, DEFAULT_CHART_FORMAT.datasets.views);
        viewsData.data = window.chartValues;
        settings.data.datasets.push(viewsData);


        const statChart = new Chart(chartCtx, settings)

        function get_labels(date_from, date_to) {
            const labels = [];
            const date = date_from;
            do {
                let day = date.getDate();
                if (day < 10) {
                    day = `0${day}`;
                }
                let month = date.getMonth() + 1;
                if (month < 10) {
                    month = `0${month}`;
                }
                labels.push(`${day}.${month}`);
                date.setDate(date.getDate() + 1);
                date.setUTCHours(0, 0, 0, 0);
            } while (date <= date_to);
            return labels;
        }
    }

    function readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $photoPreview.attr('src', e.target.result);
            }

            reader.readAsDataURL(input.files[0]); // convert to base64 string
        }
    }


    $form.on('change', '#profile-photo', (e) =>{
        readURL(e.target);
    });

    $companyForm.on('change', '#profile-photo', (e) =>{
        readURL(e.target);
    });
})();
